import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { OnboardingProgressService } from '../services/onboarding-progress.service';

/**
 * Hydrates the onboarding/session store from the API before any other
 * gamification guard reads it. Required after a full page refresh because
 * the store is in-memory only.
 */
export const GamificationSessionGuard: CanActivateFn = () => {
    const onboarding = inject(OnboardingProgressService);
    const router = inject(Router);

    return onboarding.ensureSession().pipe(
        map(ok => (ok ? true : router.createUrlTree(['sign-in']))),
    );
};
